module.exports = __webpack_public_path__ + "media/video-corporativo-y-eventos_reel.d41295f7.webm";